<template>
  <div class="table-wrapper">
    <div class="table" ref="table">
      <div
        :class="[{'items-center': itemsCenter}, 'table-head', {'table-head_sticky': sticky}]"
        :style="{'grid-template-columns': columnTemplates}">
        <div :class="[
            {'start-head': alignLeft},
            {'black-title': blackTitle},
            {'title-center': titleCenter},
            'table-head__name'
          ]"
          v-for="(element, i) of head"
          :key="i">
          <div class="table-head__name_title">
            <button
              @click="copyDataToAllWeeks(i)"
              class="btn btn_blue copy-data__button"
              v-if="isOverbooking && i !== 0">
              <inline-svg :src="require(`@/assets/svg/overbooking_copy.svg`)" />
            </button>
            <div
              class="table-head__name-element"
              v-html="element"
            />
          </div>
        </div>
      </div>
      <div 
        class="table-matrix" 
        :style="{'grid-template-columns': columnTemplates}" 
        v-if="matrixTable">
        <slot></slot>
      </div>
      <div v-else>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import {timePeriod} from '@/helpers/timeForSelect'
export default {
  name: "BaseTable",
  props: {
    headHeightStatic: {
      type: Number, String,
      required: false,
      default: 70
    },
    isOverbooking: {
      type: Boolean,
      required: false
    },
    matrixTable: {
      type: Boolean,
      required: false
    },
    titleCenter: {
      type: Boolean,
      required: false
    },
    itemsCenter: {
      type: Boolean,
      required: false
    },
    blackTitle: {
      type: Boolean,
      required: false
    },
    alignLeft:{
      type: Boolean,
      required: false
    },
    head: {
      type: Array,
      required: false,
    },
    headHeightSticky: {
      type: String,
      required: false,
      default: '50px'
    },
    columnTemplates: {
      type: String,
      required: false
    },
    sticky: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data(){
    return {
      timePeriod,
      isMounted: false,
      widthTable: 0,
      widthHeader: 0
    }
  },
  methods: {
    copyDataToAllWeeks(columnIndex) {
      this.$emit('copyDataToAllWeeks', columnIndex)
    },
  }
};
</script>

<style lang="scss" scoped>
.items-center {
  justify-items: center;
}
.table {
  background-color: #fff;
  width: 100%;
  margin-bottom: 40px;
  margin-top: 15px;
  &-wrapper {
     display: flex;
     justify-content: center;
  }
  &-head {
    padding: 5px 16px;
    display: grid;
    column-gap: 10px;
    align-items: center;
    border-bottom: 2px solid #EEEFF4;
    background: #fff;
    &_sticky {
      position: sticky;
      top: 0;
      z-index: 1;
    }
    &.vue-sticky-element--stuck {
      width: calc(100% - 220px)
    }
    &__name {
      display: flex;
      // flex-direction: column;
      justify-content: flex-start;
      color: #9C9C9C;
      text-align: center;
      &-element {
        text-align: center;
        position: relative;
        font-size: 14px;
        font-weight: 500;
      }
      &.title-center {
        display: block;
      }
    }
    &-row {
      display: flex;
    }
  }
  &-matrix {
    display: grid;
    background: #fff;
  }
  &-column {
    border: 1px solid #000;
    text-align: center;
  }
}
.start-head {
  justify-content: flex-start
}
.black-title {
  color: #000;
}
.copy-data__button {
  padding: 0 15px;
  margin: 0 auto 7px auto;
  width: 55px;
  min-width: auto;
}
</style>
